module.exports = __webpack_public_path__ + "node_modules/@taxfyle/web-commons/lib/components/AwesomeLoader/loader-128.gif";


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/AwesomeLoader/loader-128.gif
// module id = 1148
// module chunks = 0